import { render } from "./ghgInventory.vue?vue&type=template&id=ef290afc&ts=true"
import script from "./ghgInventory.vue?vue&type=script&lang=ts"
export * from "./ghgInventory.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__